import { L } from '@lang';
import { Placeholder, CopyLink } from '../../../../shared/ui';
import { ReactComponent as LogoIcon } from '../../../../shared/assets/icon-vkd-logo-72.svg';

export function OtherInstallCopy() {
  return (
    <Placeholder
      icon={<LogoIcon />}
      title={L.t('pwa_install_other_copy_title')}
      action={
        <CopyLink
          placeholder={window.location.origin + window.location.pathname}
          url={window.location.href}
          buttonLabel={L.t('pwa_install_other_copy_button')}
          copiedLabel={L.t('pwa_install_other_copy_button_copied')}
        />
      }
      stretched
    >
      {L.t('pwa_install_other_copy_subtitle')}
    </Placeholder>
  );
}
